// components/SubnoteBreadcrumb.js
import React from 'react';
import { ChevronLeft, ArrowLeft } from 'lucide-react';
import styles from './SubnoteBreadcrumb.module.css';
import { useNotes } from './contexts/NotesContext';

const SubnoteBreadcrumb = () => {
  const { notes, selectedNoteId, selectNote, getSelectedNote } = useNotes();
  
  // Get the currently selected note using the helper function
  const selectedNote = getSelectedNote();
  
  // Return null if there's no selected note or if it's not a subnote
  if (!selectedNote || !selectedNote.parent_id) {
    return null;
  }
  
  // Find the parent note
  const parentId = selectedNote.parent_id;
  const parentNote = notes.find(note => note.id === parentId);
  
  // If parent not found, don't show breadcrumb
  if (!parentNote) {
    return null;
  }
  
  return (
    <div className={styles.breadcrumb}>
      <button 
        className={styles.backButton}
        onClick={() => selectNote(parentNote.id)}
        title={`Back to ${parentNote.title || "Untitled"}`}
      >
        <ArrowLeft size={16} className={styles.backIcon} />
        <span className={styles.breadcrumbItem}>
          Back to {parentNote.title || "Untitled"}
        </span>
      </button>
    </div>
  );
};

export default SubnoteBreadcrumb;